// import appInfo from '@/app-info'
// import axios from 'axios'
// import router from '@/router';

const emptyData = {
  TagName: '',
  CustomerName: '',
  TagType: '',
  Note: ''
}

// var validateName = async (name) => {
// 	try {
// 		var id = router.history.current.params.id;
// 		var idParam = "";

// 		if (id) {
// 			idParam = `&userId=${id}`
// 		}
// 		const res = await axios.get(
// 			appInfo.api.user.isAvailableUsername + '?username=' + name + idParam
// 		)
// 		return res.data;
// 	} catch (e) {
// 		console.log(e)
// 	}
// };

// var validateUsername = async (rule, value, callback) => {
// 	if (value == '') {
// 		callback(new Error('Username is required'))
// 	} else if (! await validateName(value)) {
// 		callback(new Error('Username Already used'));
// 	} else {
// 		callback();
// 	}
// };

const validationRules = {
  TagName: [
    {
      required: true,
      message: 'Tag Name is required',
      trigger: 'blur'
    }
  ],
  CustomerName: [],
  TagType: [],
  Note: []
}

export default {
  getEmptyData() {
    return emptyData
  },
  getValidationRule() {
    return validationRules
  }
}
